exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content h5[data-v-05cde0c1]{margin-bottom:0}.card[data-v-05cde0c1]{border:1px solid #54545c;-webkit-box-shadow:2px 2px 2px 0 #000;-moz-box-shadow:2px 2px 2px 0 #54545c;box-shadow:2px 2px 2px 0 #54545c}.tags[data-v-05cde0c1]{justify-content:center}.button.is-fullwidth[data-v-05cde0c1]{margin-top:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05cde0c1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventario_Componentes/CardArticulo.vue
// module id = 1998
// module chunks = 0